var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 14.6138L12 9.99995L17 14.6138L7 14.6138Z","fill":"#00121A","key":0}),React.createElement("mask",{"id":"mask0","maskType":"alpha","maskUnits":"userSpaceOnUse","x":"7","y":"10","width":"10","height":"5","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 10L12 14.6138L7 10L17 10Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0)","key":2})]);
}

ArrowUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
